var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vCenter collectbtndiv",on:{"click":function($event){_vm.collect()}}},[_c('img',{attrs:{"src":_vm.favorites==0?'/img/icon/collect.png':'/img/icon/collected.png',"alt":""}}),_vm._v(" "),(_vm.favorites==0)?_c('div',{staticClass:"btntext"},[_vm._v("\n    收藏\n  ")]):_c('div',{staticClass:"btntext"},[_vm._v("\n    取消\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5aa53e2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/collect/um-collect.vue
// module id = 112
// module chunks = 0